import { Root } from 'domelementtype';
import { isComment, isTag, isText } from 'domhandler';
// Comment type guard
export const isCommentElement = isComment;
// Cheerio<Element> type guard
export const isCheerioRootElement = (el) => typeof el.children === 'function';
export const isRootNode = (el) => el.type === Root;
// Tag type guard
export const isTagElement = isTag;
// Text type guard
export const isTextElement = isText;
//# sourceMappingURL=util.js.map